import Loadable from '../../../components/loadable';

const ContactWaivers = Loadable({
  loader: () => import('../../../pages/contacts/waivers'),
  type: 'block',
});

angular.module('gym').value('ContactWaivers', ContactWaivers);
